<div class="button-component-wrapper">
  <button class="button-component button-component--red"
          [class.button-component--primary]="variant === 'primary'"
          [class.button-component--secondary]="variant === 'secondary'"
          [class.button-component--outline]="variant === 'outline'"
          [class.button-component--full]="fullWidth"
          [disabled]="disabled || loading"
          (click)="onClick($event)"
          [routerLink]="href ?? null"
  >
    <span class="button-component__spinner" *ngIf="loading"></span>

    <ng-content select="[icon]"></ng-content>

    <span class="button-component__label">{{ label }}</span>
  </button>

</div>
